import React from "react";

const BusinessAssets = () => {
  return (
    <div className="p-4 bg-white rounded shadow mb-6">
      <h3 className="text-xl font-bold text-blue-600 mb-4 text-left">
        WhatsApp Business Assets
      </h3>

      <div className="mb-6 p-4 border rounded bg-gray-50">
        <h4 className="text-lg font-semibold text-blue-500 mb-2 text-left">
          M3i Solutions
        </h4>
        <ul className="text-left">
          <li>
            <strong>Business Account:</strong> M3i Solutions
          </li>
          <li>
            <strong>Phone Number:</strong> 7795076327
          </li>
          <li>
            <strong>Address:</strong> Muddinapalya Main Road, #42, 2nd Floor,
            Shiva Arcade, Vishweshwaraiah Layout, Naagarabhaavi, Bengaluru,
            Karnataka 560056
          </li>
          <li>
            <strong>Webhook Subscriptions:</strong> Enabled
          </li>
        </ul>
      </div>

      <div className="p-4 border rounded bg-gray-50">
        <h4 className="text-lg font-semibold text-blue-500 mb-2 text-left">
          KNS
        </h4>
        <ul className="text-left">
          <li>
            <strong>Business Account:</strong> KNS
          </li>
          <li>
            <strong>Phone Number:</strong> 9901855044
          </li>
          <li>
            <strong>Address:</strong> NO. 1125/12, 1st Floor, Service Rd,
            Vijayanagar 2nd stage, Hampi Nagar, RPC Layout, Vijayanagar,
            Bengaluru, Karnataka 560104
          </li>
          <li>
            <strong>Webhook Subscriptions:</strong> Enabled
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BusinessAssets;
